module.exports = __webpack_public_path__ + "static/media/summaryicon.1b47d2a3.png";